<script setup lang="ts">
	const { menus } = useMenus();

	function scrollToHeader() {
		document.getElementById('header')?.scrollIntoView();
	}
</script>

<template>
	<footer class="app-footer">
		<div class="app-footer__wrapper">
			<div class="app-footer__main-content">
				<div class="app-footer__logo-block">
					<NuxtLink to="/" class="app-footer__logo-link" @click="scrollToHeader">
						<NuxtImg src="/images/svg/logo.svg" alt="logo" class="app-footer__logo" />
					</NuxtLink>
					<div class="app-footer__logo-description">Авиаперевозки из Китая</div>
				</div>
				<div class="app-footer__link-list app-footer__link-list--menu">
					<div class="app-footer__title-list">Меню</div>
					<NuxtLink
						v-for="menuItem in menus"
						:key="menuItem.title"
						:to="menuItem.path"
						class="link"
					>
						{{ menuItem.title }}
					</NuxtLink>
				</div>
				<div class="app-footer__link-list">
					<div class="app-footer__title-list">Контакты</div>
					<a :href="CONTACTS.phone.link" class="link">{{ CONTACTS.phone.text }}</a>
					<a :href="CONTACTS.email.link" class="link">{{ CONTACTS.email.text }}</a>
				</div>
				<div class="app-footer__link-list">
					<div class="app-footer__title-list">Наши ответвления</div>
					<a :href="CONTACTS.autoTransportation.link" target="_blank" rel="noopener" class="link">
						{{ CONTACTS.autoTransportation.text }}
					</a>
					<a :href="CONTACTS.railTransportation.link" target="_blank" rel="noopener" class="link">
						{{ CONTACTS.railTransportation.text }}
					</a>
				</div>
			</div>
			<div class="app-footer__privacy-block">
				© 2024 ООО «Агентство Правильных Перевозок».
				<NuxtLink to="/privacy" class="link">Политика конфиденциальности</NuxtLink>
			</div>
		</div>
	</footer>
</template>

<style lang="scss" scoped>
	.app-footer {
		position: relative;
		display: flex;
		justify-content: center;
		width: 100%;
		background-color: var(--color-grey);
		box-shadow: -320px 0px 0 0 var(--color-grey), 320px 0px 0 0 var(--color-grey);
	}
	.app-footer__wrapper {
		width: 100%;
		max-width: 1200px;
		padding: 35px 0px;
	}
	.app-footer__main-content {
		margin-bottom: 24px;
		display: flex;
		flex-direction: column;
		gap: 24px;
	}
	.app-footer__logo-block {
		display: flex;
		flex-direction: column;
		justify-content: space-between;
	}
	.app-footer__logo-link {
		display: flex;
	}
	.app-footer__logo {
		width: 218px;
		height: 28px;
	}
	.app-footer__logo-description {
		margin-top: 25px;
		width: 145px;
	}

	.app-footer__link-list {
		display: flex;
		flex-direction: column;
		gap: 12px;
		.app-footer__title-list {
			font-weight: 700;
			font-size: 20px;
		}
		&.app-footer__link-list--menu {
			position: absolute;
			top: 88px;
			right: 0px;
		}
	}
	.app-footer__privacy-block {
		display: flex;
		flex-direction: column;
		justify-content: flex-end;
		align-items: end;
		text-align: end;
		text-wrap: balance;
	}

	@media (min-width: 1240px) {
		.app-footer {
			display: flex;
			justify-content: center;
			width: 100%;
			background-color: var(--color-grey);
			box-shadow: 1200px 0px 0 0 var(--color-grey), 2400px 0px 0 0 var(--color-grey),
				-1200px 0px 0 0 var(--color-grey), -2400px 0px 0 0 var(--color-grey);
		}
		.app-footer__wrapper {
			width: 100%;
			max-width: 1200px;
			padding: 50px 0px;
		}
		.app-footer__main-content {
			margin-bottom: 30px;
			display: flex;
			flex-direction: row;
			gap: 110px;
		}
		.app-footer__logo-block {
			display: flex;
			flex-direction: column;
			justify-content: space-between;
		}
		.app-footer__logo {
			width: 241px;
			height: 31px;
		}
		.app-footer__logo-description {
			margin-top: 0px;
			width: 145px;
		}

		.app-footer__link-list {
			display: flex;
			flex-direction: column;
			gap: 12px;
			.app-footer__title-list {
				font-weight: 700;
				font-size: 20px;
			}
			&.app-footer__link-list--menu {
				position: relative;
				right: 0px;
				top: 0;
			}
		}
		.app-footer__privacy-block {
			display: flex;
			flex-direction: row;
			justify-content: flex-end;
		}
	}
</style>
